import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrls: ['./business-detail.component.sass']
})
export class BusinessDetailComponent implements OnInit {
  docId;
  item;
  coverImage: string = "./assets/img/no-cover.png";
  logoImage: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';
  

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {
      this.ngOnInit();
    }

  ngOnInit(): void {
    this.docId = this.aroute.snapshot.paramMap.get('id');
    this.item = this.db.getBusinessDetails(this.docId);
    this.db.CheckDocPublish('businesses', this.docId, 'popular/businesses')
    
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });    
  }
    
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }


}